import Classification from "./classification";
import Normal from "./normal";
import BalancedEquation from "./balancedEquation";
import ThePrinciples from "./thePrinciples";

import './styles.css';

export default function TransitionInitial({
  gameType,
  levelType,
  onComplete,
  numberOfAttempts = 2,
  businessType
}) {
  return (
    <div className="page-content transition-page-initial-content">
      {
        gameType === 'Account Classification' &&
          <Classification 
            levelType={levelType}
            onComplete={onComplete}
            numberOfAttempts={numberOfAttempts}
          />
      }
      {
        gameType === 'Normal Balance' &&
          <Normal 
            levelType={levelType}
            onComplete={onComplete}
            numberOfAttempts={numberOfAttempts}
          />
      }
      {
        gameType === 'Balanced Equation' &&
          <BalancedEquation 
            levelType={levelType}
            onComplete={onComplete}
            numberOfAttempts={numberOfAttempts}
            businessType={businessType}
          />
      }
      {
        gameType === 'The Principles' &&
          <ThePrinciples 
            levelType={levelType}
            onComplete={onComplete}
            numberOfAttempts={numberOfAttempts}
          />
      }
    </div>
  );
}
